import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "region-content p-3" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "district" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-map-marker-alt mr-1" }, null, -1)
const _hoisted_5 = { class: "region?-info mt-3" }
const _hoisted_6 = { class: "region-info-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "key" }, "Sản phẩm canh tác", -1)
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "region-info-item" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "key" }, "Hình thức canh tác", -1)
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "region-info-item" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "key" }, "Diện tích canh tác", -1)
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "region-info-item" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "key" }, "Người sở hữu", -1)
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "region-info-item" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "key" }, "Số điện thoại", -1)
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "region-info-item" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "key" }, "Địa chỉ", -1)
const _hoisted_23 = { class: "value" }
const _hoisted_24 = { class: "region-info-item" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "key" }, "Tỉnh thành", -1)
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "region-info-item" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "key" }, "Quận/ huyện", -1)
const _hoisted_29 = { class: "value" }
const _hoisted_30 = { class: "region-info-item" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "key" }, "Xã/ phường", -1)
const _hoisted_32 = { class: "value" }
const _hoisted_33 = {
  key: 0,
  class: "region-info-image"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "key" }, "Hình ảnh canh tác", -1)
const _hoisted_35 = { class: "list-image mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeCarousel = _resolveComponent("HomeCarousel")!
  const _component_Avatar3 = _resolveComponent("Avatar3")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createBlock(_component_Loading, { loading: _ctx.loading }, {
    default: _withCtx(() => [
      _createVNode(_component_HomeCarousel, {
        images: _ctx.region?.listImages
      }, null, 8, ["images"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.region?.name), 1),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.region?.ward) + " ," + _toDisplayString(_ctx.region?.district) + ", " + _toDisplayString(_ctx.region?.province), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.region?.material?.name), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.region?.farmingType?.name), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.region?.area) + " ha", 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.region?.ownerName), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.region?.ownerPhone), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.region?.ownerAddress), 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.region?.province), 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.region?.district), 1)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.region?.ward), 1)
          ]),
          (_ctx.region?.listImages.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.region?.listImages, (img, index) => {
                    return (_openBlock(), _createBlock(_component_Avatar3, {
                      radius: "8px",
                      class: "mr-2",
                      width: "90px",
                      height: "90px",
                      round: false,
                      key: index,
                      avatar: img,
                      onClick: ($event: any) => (_ctx.handleViewFull(img)),
                      alt: ""
                    }, null, 8, ["avatar", "onClick"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}